/**
 *    @author:
 *    @since:
 *
 */

import { ViewportScroller } from "@angular/common";
import { Util } from "src/refresh/service/Util";
import { IValidator } from "../_common/component/IValidator";
import { Setup3Component } from "./setup_3.component";

export class Setup3Validation extends IValidator {
     constructor(private component: Setup3Component,private menuID:number) {
           super();
           this.isBornThroughSurrogacy   = this.component.data.eligibility.isBornThroughSurrogacy;
           this.isCustodyOtherThanParent = this.component.data.eligibility.isCustodyOtherThanParent;
           this.isOtherCertifyingBirth   = this.component.data.eligibility.isOtherCertifyingBirth;
           this.viewportScroller = this.component.viewportScroller;
     }

     private isBornThroughSurrogacy:string; 
     private isCustodyOtherThanParent:string;
     private isOtherCertifyingBirth:string;
     private viewportScroller:ViewportScroller;
     
     private success: boolean;

     public validate(): boolean {
          this.success = true;

          if (Util.isEmpty(this.component.eligibility.isBornThroughSurrogacy)){
               this.focus("isBornThroughSurrogacy","radio_isBornThroughSurrogacyRadio_0").error_emptyIsBornThroughSurrogacy = "setup_3.emptyIsBornThroughSurrogacy";
          }

          if (Util.isEmpty(this.component.eligibility.isCustodyOtherThanParent)){
               this.focus("isCustodyOtherThanParent","radio_isCustodyOtherThanParentRadio_0").error_emptyIsCustodyOtherThanParent = "setup_3.emptyIsCustodyOtherThanParent";
          }

          if (this.component.eligibility.isCustodyOtherThanParent === 'Y' && 
               Util.isEmpty(this.component.eligibility.isOtherCertifyingBirth )){

               this.focus("isOtherCertifyingBirth","radio_isOtherCertifyingBirthRadio_0").error_emptyIsOtherCertifyingBirth = "setup_3.emptyIsOtherCertifyingBirth";
          }

          if(this.component.eligibility.isCustodyOtherThanParent == 'Y' && 
               this.component.eligibility.isOtherCertifyingBirth == 'Y'){
                    
               if(Util.isEmpty(this.component.eligibility.isOtherSingleName) ||
                    this.component.eligibility.isOtherSingleName == 'N'){
                         
                    if(Util.isEmpty(this.component.eligibility.otherFirstName)){
                         this.focus("otherName","input_otherFirstName").error_invalidOtherFirstName = "setup_3.emptyOtherFirstName";
                    }
                    else if(!Util.isValidName(this.component.eligibility.otherFirstName)){
                         this.focus("otherName","input_otherFirstName").error_invalidOtherFirstName = "setup_3.invalidOtherFirstName";
                    }
     
                    if(Util.isEmpty(this.component.eligibility.otherLastName)){
                         this.focus("otherName","input_otherLastName").error_invalidOtherLastName = "setup_3.emptyOtherLastName";
                    }else if(!Util.isValidName(this.component.eligibility.otherLastName)){
                         this.focus("otherName","input_otherLastName").error_invalidOtherLastName = "setup_3.invalidOtherLastName";
                    }
               }else if(this.component.eligibility.isOtherSingleName == 'Y'){
                    if(Util.isEmpty(this.component.eligibility.otherSingleName)){
                         this.focus("otherSingleName","input_otherSingleNameInput").error_invalidOtherSingleName = "setup_3.emptyOtherSingleName";
                    }else if(!Util.isValidName(this.component.eligibility.otherSingleName)){
                         this.focus("otherSingleName","input_otherSingleNameInput").error_invalidOtherSingleName = "setup_3.invalidOtherSingleName";
                    }
               }
          }

          return this.success;
     }

     private jumpToError(tagId: string) : Setup3Component {
          if ( this.success ){
              this.scrollAndFocus(tagId);
              this.success = false;
          }
         
          return this.component;
     }

     private scrollAndFocus(tagId: string){
          let  content = this.component.elRef.nativeElement.querySelector('#'+tagId).parentElement;
          if ( content ) { 
               content.scrollIntoView({behavior: "smooth"});
               content.focus();
          }
     }

     private focus(tagId:string,ctrlId:string) : Setup3Component {
      if ( this.success ) {
           this.viewportScroller.scrollToAnchor(tagId);
           let ctrl = document.getElementById(ctrlId);
           //console.log(ctrl);
           if ( ctrl ) ctrl.focus();
      }
           
      this.success = false;
      return this.component;
     }

       public IdOfChanged():number { 
            
            if (  this.isBornThroughSurrogacy !=  this.component.data.eligibility.isBornThroughSurrogacy ||
                  this.isOtherCertifyingBirth !=  this.component.data.eligibility.isOtherCertifyingBirth ||
                  this.isCustodyOtherThanParent !=  this.component.data.eligibility.isCustodyOtherThanParent) return this.menuID;

              return 0;
       }

    
}